import { GridColDef } from '@mui/x-data-grid-pro';

export const COMMON_COLUMN_PROPS: Omit<GridColDef, 'field' | 'headerName'> = {
  headerAlign: 'center',
  align: 'center',
  flex: 1,
  minWidth: 100,
  sortable: true,
};

export const COLUMN_FIELDS = {
  ID: 'id',
  NAME: 'name',
  SHORT_NAME: 'shortName',
  POSITION: 'position',
  LIVE_POSITION: 'livePosition',
  IS_ACTIVE: 'isActive',
  ICON: 'icon',
  EDIT: 'edit',
  SPORT_ID: 'sportId',
  SPORT_NAME: 'sportName',
  SPORT_ICON: 'sportIcon',
  TOP_OFFER: 'topOffer',
  TOP_OFFER_POSITION: 'topOfferPosition',
  COMPETITION_ID: 'competitionId',
  COMPETITION_NAME: 'competitionName',
  FEATURED: 'featured',
  INFORMATION: 'information',
  TOURNAMENT_ID: 'tournamentId',
  TOURNAMENT_NAME: 'tournamentName',
  PARTICIPANT_ID: 'participantId',
  PARTICIPANT_NAME: 'participantName',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DISPLAY_NAME: 'displayName',
  MARKET_NAME: 'marketTypeName',
  DESCRIPTION: 'description',
  COUNTRY: 'country',
  PHONE_NUMBER: 'phone',
  CASHOUT: 'eligibleForCashout',
  EMAIL: 'email',
  DATE_CREATED: 'dateCreated',
  LAST_ONLINE: 'lastOnline',
  ADDRESS: 'address',
  ZIP_CODE: 'zip',
  CITY: 'city',
  REGION: 'region',
  LANGUAGE: 'language',
  DATE_OF_BIRTH: 'dateOfBirth',
  GENDER: 'gender',
  PARENT: 'parent',
  CAMPAIGN: 'affiliateCampaign',
  AFFILIATE: 'affiliate',
  CREATED_BY: 'createdBy',
  NATIONAL_ID: 'nationalId',
  CURRENCY: 'currency',
  START_DATE: 'startDate',
  START_TIME: 'startTime',
  RESULT: 'result',
  MODEL_OUTRIGHTS: 'publishTimeOutrightModel',
  PUBLISH_TIME_OUTRIGHTS: 'publishTimeInDaysOutrightValue',
  MODEL_MATCHES: 'publishTimeMatchModel',
  PUBLISH_TIME_MATCHES: 'publishTimeInDaysMatchValue',
  ENTITY: 'modelType',
  VERIFICATION_MESSAGE_ADMIN: 'verificationMsgAdmin',
  VERIFICATION_MESSAGE_CLIENT: 'verificationMsgClient',
  RESTRICTION_MESSAGE_ADMIN: 'restrictionMsgAdmin',
  RESTRICTION_MESSAGE_CLIENT: 'restrictionMsgClient',
  CONDITION_GROUP_NAME: 'conditionGroupName',
  USER: 'user',
  USERNAME: 'username',
  RISK_FACTOR: 'riskFactor',
  RISK_FACTOR_VALUE: 'riskFactorValue',
  PRE_MATCH_RISK_FACTOR: 'preMatchRiskFactor',
  IN_PLAY_RISK_FACTOR: 'inPlayRiskFactor',
  TYPE: 'type',
  DEVICE: 'device',
  PAID_OUT_AT: 'resolvedAt',
  TOTAL_STAKE_AMOUNT: 'totalStakeAmount',
  TOTAL_ODDS: 'totalOdds',
  BONUS_AMOUNT: 'fixedAmount',
  BONUS_PERCENTAGE: 'bonusPercentage',
  ELIGIBILITY_CRITERIA: 'eligibilityCriteria',
  BONUS_TYPE: 'bonusType',
  REWARD_TYPE: 'rewardType',
  VALIDITY_PERIOD: 'validityPeriod',
  CAP_LIMIT: 'capLimit',
  MIN_DEPOSIT_AMOUNT: 'minDepositAmount',
  TIMEFRAME: 'timeframe',
  MIN_SELECTIONS: 'minSelections',
  MIN_ODDS_PER_SELECTION: 'minOddsPerSelection',
  WAGERING_REQUIREMENT: 'wageringRequirement',
  MULTIPLIER: 'multiplier',
  MAX_BET_LIMIT: 'maxBetLimit',
  GAME_WEIGHTING_CONTRIBUTIONS: 'gameWeightingContributions',
  INCREMENTAL_UNLOCKS_ENABLED: 'incrementalUnlocksEnabled',
  UNLOCK_BATCH_PERCENTAGE: 'unlockBatchPercentage',
  SB_WAGERING: 'sbWagering',
  CASINO_WAGERING: 'casinoWagering',
  RECEIVED_BONUS: 'receivedBonus',
  POSSIBLE_WINNINGS: 'possibleWinnings',
  WINNINGS: 'winnings',
  COMBINATIONS_COUNT: 'combinationsCount',
  REOFFERED: 'reoffered',
  CANCELED: 'canceled',
  RESOLUTION_STATUS: 'status',
  IP_ADDRESS: 'ipAddress',
  ACCEPT_STATUS: 'acceptStatus',
  CREATED_AT: 'createdAt',
  TICKET_ID: 'ticketId',
  BETS_COUNT: 'betsCount',
  FROM: 'from',
  SOURCE_TYPE: 'sourceType',
  EVENT: 'event',
  BANKER: 'banker',
  IS_WAYS: 'isWays',
  BET_BUILDER: 'betBuilder',
  MARKET: 'market',
  SPECIAL_VALUE: 'specialValue',
  OUTCOME: 'outcome',
  ODDS: 'odds',
  USED_FOR: 'usedFor',
  DISPLAY_TYPE: 'displayType',
  FULL_NAME: 'fullName',
  RISK_FACTOR_ID: 'riskFactorID',
  RISK_FACTOR_NAME: 'riskFactorName',
  MIN_VERIFICATION_TRIGGER: 'minVerificationTrigger',
  MAX_VERIFICATION_TRIGGER: 'maxVerificationTrigger',
  LIABILITY_LIMIT_ID: 'liabilityLimitID',
  LIABILITY_LIMIT_NAME: 'liabilityName',
  LIABILITY_LIMIT_VALUE: 'liabilityValue',
  LIABILITY_CALCULATION: 'liabilityCalculation',
  DEFAULT_RISK_FACTOR: 'defaultRiskFactor',
  DEFAULT_MIN_TRIGGER: 'defaultMinTrigger',
  DEFAULT_MAX_TRIGGER: 'defaultMaxTrigger',
  SETTINGS: 'settings',
  SOLUTION: 'solution',
  PAYMENT_METHOD: 'paymentMethod',
  AMOUNT: 'amount',
  STATUS: 'status',
  WELCOME_BONUS_SCOPE: 'welcomeBonusScope',
  EXECUTION_TIME: 'executionTime',
  TOP_LIABILITY: 'topLiability',
  LIABILITY_PERCENTAGE: 'liabilityPercentage',
  EVENT_ID: 'eventId',
  UNIQUE_ID: 'uniqueId',
  LIMIT_ID: 'limitId',
  LIMIT_VALUE: 'limitValue',
  NUMBER_TICKET_BETS: 'numberTicketBets',
  TOP_LEAGUE: 'topLeague',
  BETTING_OPERATOR: 'operator',
  ACTIONS: 'actions',
  CRYPTO_WITHDRAWAL: 'cryptoWithdrawal',
  SOURCE_IP: 'ipAddress',
  WINNING_TICKETS: 'winningTickets',
  PRODUCT: 'product',
  PROMO_CODE: 'code',
  STAKE_RANGES: 'stakeRanges',
  WINNING_AMOUNT: 'winningAmount',
  CONTACT_NAME: 'contactName',
  ROLE: 'role',
  AGENT: 'agent',
  MARKET_COMBINED: 'marketCombined',
  COMMISSION: 'commission',
  COMMISSION_TYPE: 'commissionType',
  PARTNERS_COUNT: 'partnersCount',
  PLAYERS_COUNT: 'playersCount',
  BALANCE: 'balance',
  TOTAL_STAKE: 'totalStake',
  TOTAL_WINNINGS: 'totalWinnings',
  TOTAL_PROFIT: 'totalProfit',
  TOTAL_COMMISSION: 'totalCommission',
  TOTAL_PROFIT_AFTER_COMMISSION: 'totalProfitAfterCommission',
  TICKETS_TOTAL: 'ticketsTotal',
  TICKETS_LOST: 'ticketsLost',
  TICKETS_WON: 'ticketsWon',
  TICKETS_OPEN: 'ticketsOpen',
  OUTCOME_SHORT_NAME: 'outcomeShortName',
  OUTCOME_NAME: 'outcomeName',
  JACKPOT_AMOUNT: 'jackpotAmount',
  CASHOUT_AMOUNT: 'cashoutAmount',
  CASHOUT_TYPE: 'cashoutType',
  TOTAL_AFTER_COMMISSION: 'totalAfterCommission',
  CLICKS: 'clickCount',
  UNIQUE_CLICKS: 'uniqueClickCount',
  REGISTRATIONS: 'registrationCount',
  FIRST_DEPOSITS: 'firstDepositorsCount',
  FIRST_DEPOSIT_AMOUNT: 'totalFirstDepositAmount',
  WAGERING_SPORTSBOOK: 'wageringSportsbook',
  WAGERING_CASINO: 'wageringCasino',
  GGR: 'ggr',
  NGR: 'ngr',
  ACTIVE_PLAYERS: 'activePlayerCount',
  COMMISSION_EARNED: 'commissionAmount',
  CONVERSION_RATE: 'conversionRate',
  EARNINGS_PER_CLICK: 'earningsPerClick',
  USER_ID: 'userId',
  IBAN: 'IBAN',
  SWIFT: 'swiftCode',
  BENEFICIARY_NAME: 'beneficiaryName',
  BANK_NAME: 'bankName',
  AUTH_RESULTS: 'authResults',
  MAIN_TICKET_COUNT: 'mainTicketCount',
  BONUS_TICKET_COUNT: 'bonusTicketCount',
  TOTAL_TICKET_COUNT: 'totalTicketCount',
  OPEN_TICKET_COUNT: 'openTicketCount',
  WON_TICKET_COUNT: 'wonTicketCount',
  LOST_TICKET_COUNT: 'lostTicketCount',
  MAIN_STAKE_AMOUNT: 'mainStakeAmount',
  BONUS_STAKE_AMOUNT: 'bonusStakeAmount',
  TOTAL_COMMISSION_AMOUNT: 'totalCommissionAmount',
  MAIN_WINNING_AMOUNT: 'mainWinningAmount',
  BONUS_WINNING_AMOUNT: 'bonusWinningAmount',
  TOTAL_WINNING_AMOUNT: 'totalWinningAmount',
  MAIN_PROFIT_AMOUNT: 'mainProfitAmount',
  BONUS_PROFIT_AMOUNT: 'bonusProfitAmount',
  TOTAL_PROFIT_AMOUNT: 'totalProfitAmount',
  PROFIT_MARGIN_PERCENTAGE: 'profitMarginPercentage',
  TICKET_NO: 'userTicketId',
} as const;
